<form [formGroup]="form" class="grid grid-cols-1 md:grid-cols-2 gap-4">
  @for (field of fields; track field) {
    <div class="flex flex-col gap-2">
      <label [for]="field.key" class="text-sm block mb-1">{{ field.label | translate }}</label>
      <p-inputgroup>
        @if (field.icon && field.type !== 'textarea' && field.type !== 'password') {
          <p-inputgroup-addon>
            <i class="pi pi-{{ field.icon }}"></i>
          </p-inputgroup-addon>
        }
        @switch (field.type) {
          @case ('text') {
            <input
              [formControlName]="field.key"
              [id]="field.key"
              [placeholder]="field.placeholder || field.label | translate"
              pInputText
            />
          }
          @case ('password') {
            <p-inputgroup>
              @if (field.icon) {
                <p-inputgroup-addon>
                  <i class="pi pi-{{ field.icon }}"></i>
                </p-inputgroup-addon>
              }
              <input
                #passwordInput
                [formControlName]="field.key"
                [id]="field.key"
                [placeholder]="field.placeholder || field.label | translate"
                pInputText
                type="password"
              />
              <p-inputgroup-addon>
                <button
                  (click)="togglePasswordVisibility(passwordInput)"
                  [attr.aria-label]="
                    passwordInput.type === 'password'
                      ? ('connections.dynamicForm.showPassword' | translate)
                      : ('connections.dynamicForm.hidePassword' | translate)
                  "
                  class="border-none bg-transparent cursor-pointer p-0 m-0"
                  type="button"
                >
                  <i
                    [class.pi-eye-slash]="passwordInput.type === 'text'"
                    [class.pi-eye]="passwordInput.type === 'password'"
                    class="pi"
                  ></i>
                </button>
              </p-inputgroup-addon>
            </p-inputgroup>
          }
          @case ('number') {
            <p-input-number
              [formControlName]="field.key"
              [id]="field.key"
              [placeholder]="field.placeholder || field.label | translate"
              [useGrouping]="false"
              styleClass="w-full"
            ></p-input-number>
          }
          @case ('textarea') {
            <textarea
              [autoResize]="false"
              [formControlName]="field.key"
              [id]="field.key"
              [placeholder]="field.placeholder || field.label | translate"
              pTextarea
            ></textarea>
          }
        }
      </p-inputgroup>
      @if (form.get(field.key)?.invalid && form.get(field.key)?.touched) {
        <small class="text-red-500">
          {{ 'connections.dynamicForm.required' | translate }}
        </small>
      }
    </div>
  }
</form>
